import { formatDistance } from "date-fns";

export const reviewDateString = date => {
  return (formatDistance(date, new Date()) + " ago").replace("about ", "");
};
